import { render, staticRenderFns } from "./EditOrganizationPage.vue?vue&type=template&id=2b39e3d6"
import script from "./EditOrganizationPage.vue?vue&type=script&lang=js"
export * from "./EditOrganizationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports